<div class="label-preview-bg-picker">
  @for (bg of backgroundOptions; track bg.id) {
    <div class="label-preview-bg-option"
      [class.selected]="effectiveId() === bg.id"
      (click)="select(bg.id)">
      <div class="label-preview-bg-thumb" [style.background-image]="bg.smallBgImage" role="img" [attr.aria-label]="bg.name"></div>
      <span class="label-preview-bg-name">{{ bg.name }}</span>
    </div>
  }
</div>
